import {
  Box,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import React, { useEffect, useState } from "react";
import moment from "moment";
import createInstance from "../../../api/axiosinstance";

const UpcomingInterviews = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const aiDishaApi = createInstance("DISHA");
  const organizationId = window.sessionStorage.getItem("organizationId");
  console.log("ORGID"+organizationId);
  
  const fetchInterviews = async () => {
    try {
      const response = await aiDishaApi.get(`/upcoming_interviews`, {
        params: { organization_id: organizationId }, // Pass as query params
      });
  
      console.log("Fetched upcoming interviews:", response.data?.upcoming_interviews);
  
      if (Array.isArray(response.data?.upcoming_interviews)) {
        setData(response.data.upcoming_interviews);
      } else {
        console.error("Unexpected response structure:", response.data);
        setData([]); // Reset to an empty array if data is missing or incorrect
      }
    } catch (error) {
      console.error(
        "Error fetching interview data:",
        error.response?.data?.message || error.message
      );
    }
  };
  useEffect(() => {
    fetchInterviews();
  }, []);

  const tableHeaders = [
    {
      id: "Candidate ID",
      name: "Candidate Name",
      position: "Job Title",
      date: "Interview Date",
      interviewer: "Interviewer",
      status: "Status",
      link: "Interview Link",
      resume: "Resume",
      action: "Action",
    },
  ];
  // Filter data based on search term
  const filteredData = data.filter((item) =>
    Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setPage(1); // Reset to first page when searching
  };

  // Calculate the current page's data
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const formatDate = (dateString) => {
    return moment(dateString).format("DD/MM/YYYY");
  };

  return (
    <div>
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "1% 1%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "1%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "31px", color: "#033538" }}
          >
            Upcoming Interviews
          </Typography>
        </Box>

        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Paper
            sx={{
              p: "2px 4px",
              display: "flex",
              width: "65%",
              borderRadius: 2,
              border: "1px solid #A7A7A7",
              bgcolor: "#033538",
            }}
          >
            <IconButton type="button" sx={{ p: "8px" }} aria-label="search">
              <SearchIcon />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1, fontFamily: "poppins" }}
              placeholder="Search by Name, Email or Mobile number"
              inputProps={{ "aria-label": "search google maps" }}
              value={searchTerm}
              onChange={handleSearch}
            />
          </Paper>
        </Box>
      </Box>
      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer sx={{ mt: "25px", borderRadius: "10px" }}>
              <Table>
                <TableHead sx={{ backgroundColor: "#033538" }}>
                  {tableHeaders.map((tableHeader) => (
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "#B9B9B9",
                          borderBottom: 0,
                          borderLeft: "1px solid black",
                        }}
                      >
                        {tableHeader.id}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {tableHeader.name}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {tableHeader.position}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {tableHeader.date}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {tableHeader.interviewer}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {tableHeader.link}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {tableHeader.resume}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody>
                  {paginatedData.map((n, index) => (
                    <TableRow
                      key={n.interview_id}
                      sx={{ backgroundColor: "#006A71", marginRight: "30px" }}
                    >
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {n.candidate_id}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {n.candidate_name}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {n.job_title}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {formatDate(n.interview_date_and_time)}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {n.interview_panel}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {" "}
                        <a href={n.meeting_link} target="_blank">
                          Link
                        </a>
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        <a href={n.resume_url} target="_blank">
                          resume
                        </a>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  backgroundColor: "#033538",
                  color: "white",
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default UpcomingInterviews;
